function Solutions() {
  return (
    <section className="bg-white py-20 px-4">
      <div className="container mx-auto flex flex-col md:flex-row md:items-start gap-12 mt-20">
        {/* Text Section */}
        <div className="w-full md:w-1/2">
          <h2 className="special-header text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight">
            DELIVERING SMARTER <br/> LOGISTICS SOLUTIONS
          </h2>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed max-w-3xl mb-4">
            Founded in 2021, Speedyssey Delivery was born out of a clear vision—to simplify and optimize the last-mile delivery experience for corporate organizations. With a deep commitment to innovation and customer-centric solutions, we set out to bridge the gap between businesses and their end consumers, ensuring seamless product distribution and peace of mind at every stage of the process.
          </p>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed max-w-3xl mb-4">
            Our leadership team is comprised of seasoned professionals with expertise spanning Information Technology, Finance, Marketing, and Supply Chain Management. This diverse knowledge base enables us to strategically align operational efficiency with cutting-edge technology, positioning us as a trusted partner for businesses seeking reliability and scalability.
          </p>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed max-w-3xl mb-4">
            Through continuous innovation, we have developed a versatile business dashboard and an advanced mobile application, designed to integrate effortlessly across iOS, Android, and web platforms. These tools empower our clients with real-time visibility, operational control, and enhanced customer engagement—delivering not just products, but excellence in execution.
          </p>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed max-w-3xl">
            At Speedyssey Delivery, we are more than a logistics partner—we are a growth enabler, committed to driving efficiency, reliability, and value in every delivery.
          </p>
        </div>

        {/* Stats Section */}
        <div className="w-full md:w-1/2 flex flex-col sm:mt-56 gap-0">
          <div className="grid grid-cols-2 gap-8">
            <div>
              <div className="text-4xl md:text-5xl special-header lg:text-5xl font-thin text-[#F55109] mb-2">99%</div>
              <div className="text-sm md:text-base text-gray-600">Uptime - Platform Stability</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl special-header lg:text-5xl font-thin text-[#F55109] mb-2">100%</div>
              <div className="text-sm md:text-base text-gray-600">Positive Feedback</div>
            </div>
          </div>
          <hr className="my-6 border-gray-300" />
          <div className="grid grid-cols-2 gap-8">
            <div>
              <div className="text-4xl md:text-5xl special-header lg:text-5xl font-thin text-[#F55109] mb-2">50+</div>
              <div className="text-sm md:text-base text-gray-600">Active Partners</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl special-header lg:text-5xl font-thin text-[#F55109] mb-2">1,200+</div>
              <div className="text-sm md:text-base text-gray-600">Orders Delivered</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solutions;
